import { render } from "./main-menu.vue?vue&type=template&id=00ba2b34"
import script from "./main-menu.vue?vue&type=script&lang=js"
export * from "./main-menu.vue?vue&type=script&lang=js"

import exportComponent from "/home/bshipaa/sites/app.bitesizehipaa.com/bss/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__